import axios from "@/plugins/http.service.js";

export default {
  login(data) {
    return axios.post("api/web/admin/login", data);
  },
}